var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-box"},[_c('div',{staticClass:"title-bar"},[_vm._t("title-bar")],2),_c('div',{staticClass:"content-bar"},[_vm._t("content-bar")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }